import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { WelcomeKitOrder } from 'app/typings/WelcomeKit/deliveries';
import { apiRequest } from 'app/utils/request/api';

const path = '/gateway/hotel-logistics/welcome-kit/orders/:orderId' as const;

export const welcomeKitOrderQueryKey = [path];

export function useWelcomeKitOrder(orderId: number) {
  return useQuery({
    queryKey: [path, { orderId }],
    queryFn: () =>
      apiRequest({
        path,
        params: { orderId: orderId.toString() },
      }) as Promise<WelcomeKitOrder>,
    placeholderData: keepPreviousData,
    meta: { errorMessage: 'Error fetching Order' },
  });
}
